// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8110e1c3","963":"7afe35c8"}[chunkId] + ".chunk.js";
};